import React, {useEffect, useMemo} from "react";
import {sets} from "../data/sets";
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {Link} from "react-router-dom";
import {saveSearchPrompt} from "../reducers/controlsReducer";
import {useDispatch} from "react-redux";

export default function MtgSets() {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(saveSearchPrompt());
    }, [])

    const set = useMemo(() => (
        <>
            <Box height={48}/>
            <TableContainer component={Paper}>
                <Table sx={{minWidth: 650}} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Set</TableCell>
                            <TableCell>Cards</TableCell>
                            <TableCell>Release Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sets.map(s => (
                            <TableRow component={Link} to={`/${s.code}`} onClick={() => dispatch(saveSearchPrompt("set:" + s.code))}>
                                <TableCell><Box
                                        component="img"
                                        sx={{
                                            height: 16,
                                            width: 16,
                                            marginLeft: s.parent_set_code ? s.level : 0
                                        }}
                                        alt={s.name}
                                        src={s.icon_svg_uri}
                                    />
                                    <Typography marginLeft={2} display={"inline"}>{s.name+" ("+s.code+")"}</Typography></TableCell>
                                <TableCell><Typography>{s.card_count}</Typography></TableCell>
                                <TableCell><Typography>{s.released_at}</Typography></TableCell>
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>
        </>
    ), []);

    return set
}
